export function wrMsg(fr:string,en:string,langue:string)
{
    if(langue=="EN")
        return en;
    return fr
}